import React from 'react';
import { store } from '../store';
import { setInfoFeedMessage, removeInfoFeedMessage } from '../store/actions';
import ReactDOM from 'react-dom';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Map from 'ol/Map';
import View from 'ol/View';
import { Text, Stroke, Fill, Style, RegularShape } from 'ol/style';
import Draw from 'ol/interaction/Draw';
import Select from 'ol/interaction/Select';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import * as olProj from 'ol/proj';
import { boundingExtent, containsCoordinate } from 'ol/extent';
import Overlay from 'ol/Overlay';
import { cloneDeep, toArray as _toArray } from 'lodash';
import { pointerMove } from 'ol/events/condition';
import '../styles/openLayers.scss';
import 'ol/ol.css';
import { defaultStyle, defaultTextStyle } from './maps/olStyles.js';
import Layer from 'ol/layer/Layer';
import { toLonLat } from 'ol/proj';
import { defaults as defaultInteractions } from 'ol/interaction';

import mapboxgl from 'mapbox-gl';

const FIT_PADDING = [20, 20, 20, 20];

class OLMap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drawPoly: null,
      freeDrawToggle: false,
      isDrawingPoly: false,
      popup: {
        contents: '',
        coord: null,
      },
      lassoPolys: [],
      lassoPointIds: [],
      focusedPoints: [], // used to set the bounds on the map w/o rerendering
      showPointLabels: false,
      infoOverlayText: {},
    };

    this.STREET_TILES = 'mapbox/light-v10'; // 'alexgilson/cln0t7tb106ah01p95imrdcc3';
    this.SAT_TILES = 'alexgilson/clnbv532d07jl01p75xj9hjhs';
    this.tileType = this.STREET_TILES;
    this.map_access_token =
      'pk.eyJ1IjoiYWxleGdpbHNvbiIsImEiOiJjbG4wdDJ4eGMxcGcwMmlxdXNwa3A1ZXc5In0.dINhFz-zHChgqP0LCjgK9w';
    this.map = null;
    this.featuresLayer = null;

    this.drawMessageOn = 'Draw Mode On';
    this.freeDrawMessage = 'Hold Shift to Free Draw';
    this.selectedMessage = ' Total Sites Selected'; // has length added dynamically when message is set.

    this.currZoom = 0; //used for comparison in the onMoveEnd event

    this.addFeatures = this.addFeatures.bind(this);
    this.addPoint = this.addPoint.bind(this);
    this.displayTooltip = this.displayTooltip.bind(this);
    this.getPoint = this.getPoint.bind(this);
    this.removePoints = this.removePoints.bind(this);
    this.clearLassos = this.clearLassos.bind(this);

    mapboxgl.accessToken = this.map_access_token;
    this.mapBoxMap = null;
  }

  handleZoomClick = (out = false) => {
    let currview = this.map.getView();
    let zoom_increment = out ? -1 : 1;

    currview.setZoom(this.currZoom + zoom_increment);
  };

  buildZoomInOutButtons = () => {
    const IN = false;
    const OUT = true;

    return (
      <div className={'map-btn-group-2'}>
        <div className={'custom-map-control'}>
          <div className={`btn`} onClick={() => this.handleZoomClick(IN)}>
            <i className="fa fa-plus" aria-hidden="true" />
          </div>
        </div>

        <div className={'custom-map-control'}>
          <div className={`btn`} onClick={() => this.handleZoomClick(OUT)}>
            <i className="fa fa-minus" aria-hidden="true" />
          </div>
        </div>
      </div>
    );
  };

  handleSwitchTile = () => {
    if (this.tileType === this.STREET_TILES) {
      this.tileType = this.SAT_TILES;
      this.props.mapTypeCallBack('satellite');
    } else if (this.tileType === this.SAT_TILES) {
      this.tileType = this.STREET_TILES;
      this.props.mapTypeCallBack('streets');
    }

    this.mapBoxMap.setStyle(
      'https://api.mapbox.com/styles/v1/' + this.tileType + '?access_token=' + this.map_access_token
    );
  };

  buildSwitchTileButton = () => {
    return (
      <div className={'custom-map-control globe'}>
        <div
          className={`btn ${this.tileType === this.SAT_TILES ? 'focused' : ''}`}
          onClick={this.handleSwitchTile}
        >
          <i className="fa fa-globe" aria-hidden="true" />
        </div>
      </div>
    );
  };

  // none -> Control
  // used to build the button on the map to stop lasso mode

  handleLasso = (e) => {
    if (this.map.getInteractions().getArray().includes(this.state.drawPoly)) {
      // let infoObj = this.state.infoOverlayText;
      // infoObj["dblClickInfo"].visible = false;
      // infoObj["shiftInfo"].visible = false;

      this.map.removeInteraction(this.state.drawPoly);
      store.dispatch(removeInfoFeedMessage(this.drawMessageOn));
      store.dispatch(removeInfoFeedMessage(this.freeDrawMessage));
      this.setState({
        isDrawingPoly: false,
        // infoOverlayText: infoObj,
      });
    } else {
      // let infoObj = this.state.infoOverlayText;
      // infoObj["dblClickInfo"].visible = true;
      // infoObj["shiftInfo"].visible = true;

      this.map.addInteraction(this.state.drawPoly);
      // remove then add
      store.dispatch(removeInfoFeedMessage(this.drawMessageOn));
      store.dispatch(removeInfoFeedMessage(this.freeDrawMessage));
      store.dispatch(setInfoFeedMessage(this.drawMessageOn));
      store.dispatch(setInfoFeedMessage(this.freeDrawMessage));

      this.setState({
        isDrawingPoly: true,
        isFreeDrawing: false,
        // infoOverlayText: infoObj,
      });
    }
  };

  buildLassoButton = () => {
    return (
      <div className={'custom-map-control'}>
        <div
          className={`btn ${this.state.isDrawingPoly ? 'focused' : ''}`}
          onClick={this.handleLasso}
        >
          <i className="fas fa-pencil-alt" aria-hidden="true" />
        </div>
      </div>
    );
  };

  handleDrag = () => {
    // let infoObj = this.state.infoOverlayText;
    // infoObj["dblClickInfo"].visible = false;
    // infoObj["shiftInfo"].visible = false;

    this.map.removeInteraction(this.state.drawPoly);
    this.map.removeInteraction(this.state.freeDraw);

    store.dispatch(removeInfoFeedMessage(this.drawMessageOn));
    store.dispatch(removeInfoFeedMessage(this.freeDrawMessage));

    this.setState({
      isDrawingPoly: false,
      isFreeDrawing: false,
      // infoOverlayText: infoObj,
    });
  };

  buildDragButton = () => {
    return (
      <div className={'custom-map-control'}>
        <div
          className={`btn primary ${
            this.state.isDrawingPoly || this.state.isFreeDrawing ? '' : 'focused'
          }`}
          onClick={this.handleDrag}
        >
          <i className="fas fa-mouse-pointer" />
        </div>
      </div>
    );
  };

  // takes an array w/ lat,lng data and fits the map view to it.
  setFocusedFeatures(points) {
    if (points && points.length) {
      let coords = points.map((point) => olProj.fromLonLat([point.lon, point.lat]));
      let extent = boundingExtent(coords);
      this.map.getView().fit(extent, { padding: FIT_PADDING });
      this.setState({ focusedPoints: points });
    }
  }

  // [List-of Feature] -> [List-of Feature]
  // Used to digest and format a list of features for display on the map
  // This function is exposed to the parent component
  addFeatures(features, key) {
    console.log('addFeatures', features);
    let tempFeatures = [];
    features &&
      features.forEach((item, i) => {
        let tempFeature = this.addPoint(item, false);
        if (tempFeature) tempFeatures.push(tempFeature);
      });

    if (this[key]) {
      this[key].getSource().addFeatures(tempFeatures);
    }
    return tempFeatures;
  }

  //used to removed a passed list of features
  removeFeatures(features, key) {
    let tempFeatures = [];
    features &&
      features.forEach((item, i) => {
        let tempFeature = this.removePoints(item.id);
      });
  }

  // point, boolean -> point
  // helper function to addFeatures, but also can be used on its own
  // thats why the addToSource toggle is there
  // this function is exposed to the parent component
  addPoint(point, addToSource = true) {
    //filters out null pointer as well as the point [0, 0]
    point.lon = point.longitude || point.lon;
    point.lat = point.latitude || point.lat;
    if (parseFloat(point.lon) && parseFloat(point.lat) && [point.lon, point.lat] !== [0, 0]) {
      let feature = new Feature({
        geometry: new Point(olProj.fromLonLat([parseFloat(point.lon), parseFloat(point.lat)])),
        tooltip: point.tooltip,
        id: point.id,
        name: point.name,
        className: point.className,
        data: point,
        // onClick: point.onClick
      });

      feature.setStyle(
        cloneDeep(point.style) || cloneDeep(this.props.defaultPointStyle) || cloneDeep(defaultStyle)
      );

      if (this.featuresLayer && addToSource) {
        this.featuresLayer.getSource().addFeature(feature);
      }

      return feature;
    } else {
      console.error('NaN lon or lat');
      return false;
    }
  }

  // point -> boolean
  // finds out of a point is within the view of the map, returns true if so
  // this function is exposed to the parent component
  displayTooltip(point) {
    let e = this.map.getView().calculateExtent(this.map.getSize());
    return containsCoordinate(e, olProj.fromLonLat([parseFloat(point.lon), parseFloat(point.lat)]));
  }

  // string -> point
  // attempts to find a feature that is on the map with the set id,
  // if it is found, the point is returned
  // this function is exposed to the parent component
  getPoint(id) {
    let focus = this.featuresLayer.getSource().forEachFeature((f) => {
      if (f.get('id') && f.get('id') === id) {
        return f;
      }
    });
    return focus;
  }

  // (string OR coordsPair) string -> void;
  // takes the data that is being matched along with a classification for that
  // data (className, id, or coords), and removes each feature from the map that
  // matches
  // this function is exposed to the parent component
  removePoints(data, type, key) {
    if (!type) type = 'id';
    if (!key) key = 'featuresLayer';

    if (type === 'className') {
      this.featuresLayer.getSource().forEachFeature((f) => {
        if (f.get('className') && f.get('className') === data) {
          this[key].getSource().removeFeature(f);
        }
      });
    } else if (type === 'id') {
      this.featuresLayer.getSource().forEachFeature((f) => {
        if (f.get('id') && f.get('id') === data) {
          this[key].getSource().removeFeature(f);
          return;
        }
      });
    } else if (type === 'coords') {
      this.featuresLayer.getSource().forEachFeature((f) => {
        if (f.getGeometry().flatCoordinates === data) {
          this[key].getSource().removeFeature(f);
        }
      });
    }
  }

  // void -> void
  // used to remove each poly feature that was added in the session using the
  // lasso tool
  // this funcion is exposed to the parent component
  clearLassos() {
    this.state.lassoPolys.forEach((item, i) => {
      try {
        this.featuresLayer.getSource().removeFeature(item.poly);
      } catch (e) {
        console.warn('polygon had already been removed', e);
      }
    });

    this.setState({ lassoPolys: [], lassoPointIds: [] });
    this.props.clearParentShapes && this.props.clearParentShapes();
  }

  // polygon -> [List-of Points]
  // returns list of points that are within the polygon
  getPointsInside(poly) {
    let internalPoints = [];

    let extent = poly.getExtent();
    let source = this.featuresLayer.getSource();

    source.forEachFeatureInExtent(extent, (e) => {
      if (
        e.getGeometry().getType() == 'Point' &&
        poly.intersectsCoordinate(e.getGeometry().getCoordinates())
      ) {
        internalPoints.push(e);
      }
    });
    return internalPoints;
  }

  //sets Labels on the points.
  setPointLabels = (remove = false) => {
    this.featuresLayer.getSource().forEachFeature((f) => {
      let style = f.getStyle();
      console.log('style', style);
      if (style) {
        if (remove) {
          try {
            style.setText();
          } catch (e) {
            console.warn(e);
          }
        } else {
          try {
            style.setText(
              new Text({
                offsetY: 14,
                fill: new Fill({
                  color: '#000',
                }),
                stroke: new Stroke({
                  color: '#FFF',
                  width: 3,
                }),
                backgroundFill: new Fill({
                  color: 'rgba(255, 255, 255, 0.1)',
                }),
                text: f.get('name'),
                font: '12px sans-serif',
              })
            );
          } catch (e) {
            console.warn(e);
          }
        }

        f.setStyle(style);
      }
    });
  };

  // where points is the array of points that you want to change, and style is the style that you want to change them too
  editSomePointStyles = (point_ids, style, labels = [], disabled = false) => {
    if (labels.length) {
      this.featuresLayer.getSource().forEachFeature((f, i) => {
        let feature_id = f.get('id') || 0;
        if (point_ids.includes(feature_id)) {
          // we must get text if displayed so that it is preserved

          let newStyle = cloneDeep(style);
          newStyle.setText(defaultTextStyle(labels.find((l) => l.id == feature_id).name));
          // let currStyle = f.getStyle();
          f.setStyle(newStyle);
        }
      });
    } else {
      this.featuresLayer.getSource().forEachFeature((f) => {
        let feature_id = f.get('id') || 0;
        if (point_ids.includes(feature_id)) {
          let newStyle = cloneDeep(style);
          f.setStyle(newStyle);
        }
      });
    }
  };

  onMoveEnd = (e) => {
    let newZoom = this.map.getView().getZoom();

    if (this.currZoom > newZoom) {
      this.props.zoomOutCallBack && this.props.zoomOutCallBack(newZoom);
    } else if (this.currZoom < newZoom) {
      this.props.zoomInCallBack && this.props.zoomInCallBack(newZoom);
    } else {
      this.props.panCallBack && this.props.panCallBack(this.map.getView().getCenter());
    }

    // You can uncomment this code to re-enable setting text on the points in the zoom styling.
    if (this.props.displayTextZoomLevel) {
      const ZOOM_TEXT_LEVEL = this.props.displayTextZoomLevel;
      if (newZoom > ZOOM_TEXT_LEVEL && this.currZoom <= ZOOM_TEXT_LEVEL) {
        this.setPointLabels();
      } else if (newZoom < ZOOM_TEXT_LEVEL && this.currZoom >= ZOOM_TEXT_LEVEL) {
        const REMOVE = true;
        console.log('removing labels');
        this.setPointLabels(REMOVE);
      }
    }

    //reset the currzoom
    this.currZoom = newZoom;

    this.props.boundsCallBack &&
      this.props.boundsCallBack(this.map.getView().calculateExtent(this.map.getSize()));
  };

  handleNewPoly = (e) => {
    let newPoly = e.feature;

    let polys = this.state.lassoPolys.slice();
    let lassoedPointArr = this.getPointsInside(newPoly.getGeometry());
    let point_ids = this.state.lassoPointIds.slice();
    let lassoed_ids = [];

    //check if all selected points are already considered lassoed points. If so, remove them.
    let removal = true;
    lassoedPointArr.forEach((point) => {
      if (!point_ids.includes(point.get('id'))) {
        removal = false;
      }
    });

    if (!removal) {
      lassoedPointArr.forEach((point) => point_ids.push(point.get('id')));
      // highlight selected points
      // this.editSomePointStyles(point_ids, simplePointStyle('#fadd23', 6, '#171716'));
    } else {
      lassoed_ids = lassoedPointArr.map((point) => point.get('id'));
      point_ids = point_ids.filter((d) => !lassoed_ids.includes(d));
      // this.editSomePointStyles(point_ids, defaultStyle);
    }

    polys.push({ poly: newPoly, points: lassoedPointArr });

    this.setState({ lassoPolys: polys, lassoPointIds: point_ids });

    this.props.polygonClosedCallBack &&
      this.props.polygonClosedCallBack({
        poly: e.feature,
        points: point_ids,
        removed_points: lassoed_ids,
      });
  };

  resetFeatureLayer = () => {
    this.featuresLayer.getSource().clear();
    this.addFeatures(this.props.features, 'featuresLayer');
    this.fitExtent();
  };

  componentDidMount() {
    // creating freature layer and vector source;

    this.featuresLayer = new VectorLayer({
      source: new VectorSource({
        features: this.addFeatures(this.props.features),
      }),
    });

    //this map box map is being used as a OL layer, so all the controls are set to negative
    this.mapBoxMap = new mapboxgl.Map({
      style:
        'https://api.mapbox.com/styles/v1/' +
        this.tileType +
        '?access_token=' +
        this.map_access_token,
      attributionControl: false,
      boxZoom: false,
      container: this.props.target || 'map',
      doubleClickZoom: false,
      dragPan: false,
      dragRotate: false,
      interactive: false,
      keyboard: false,
      pitchWithRotate: false,
      scrollZoom: false,
      touchZoomRotate: false,
    });

    // this is where we turn the map into a layer, all the interaction is coming through the OL api, and being fed to map box
    // this was done so we could use vector layers, ol-mapbox-style was causing a memory leak, so this was the solution
    // this might break when OL/mapbox is updated, so if the map stops working, this could be the cause, make sure to check either the OL
    // upgrade breaks or the mapbox upgrade breaks, by the time that happens, there might be a more streamlined solution worth looking at
    const mapBoxLayer = new Layer({
      zIndex: -999,
      render: (frameState) => {
        let canvas = this.mapBoxMap.getCanvas();
        let viewState = frameState.viewState;

        let visible = mapBoxLayer.getVisible();
        canvas.style.display = visible ? 'block' : 'none';

        let opacity = mapBoxLayer.getOpacity();
        canvas.style.opacity = opacity;

        this.mapBoxMap.jumpTo({
          center: toLonLat(viewState.center),
          zoom: viewState.zoom - 1,
          animate: false,
        });

        if (this.mapBoxMap._frame) {
          this.mapBoxMap._frame.cancel();
          this.mapBoxMap._frame = null;
        }
        this.mapBoxMap._render();

        return canvas;
      },
    });

    // create map object with the feature layer
    this.map = new Map({
      controls: [], //disable default
      target: this.props.target || 'map',
      interactions: defaultInteractions({
        pinchRotate: false,
        altShiftDragRotate: false,
      }), // so our layers don't get messed up on mobile
      layers: [
        //default layer
        mapBoxLayer,
        this.featuresLayer,
      ],
      view: new View({
        center: [-98579516.28195593, 3982283.172379018],
        zoom: 3,
      }),
    });

    // overlay for the tooltip popup
    const overlay = new Overlay({
      element: ReactDOM.findDOMNode(this).querySelector('#overlay'),
      positioning: 'center-center',
      stopEvent: false,
    });

    this.map.getView().setMaxZoom(18);

    this.map.addOverlay(overlay);

    this.map.on('click', (e) => {
      // e.preventDefault();
      // e.stopPropagation();
      this.map.forEachFeatureAtPixel(e.pixel, (feature, layer) => {
        // this.map.removeInteraction(this.state.drawPoly);
        feature.get('onClick') && feature.get('onClick')(e);
      });
    });

    this.map.on('dblclick', (e) => {
      // remove shapes on double click and reset the point colors.
      if (this.props.disableDblClick) return;
      // this.editSomePointStyles(this.state.lassoPointIds, defaultStyle);
      this.props.onDblClick && this.props.onDblClick();
      this.clearLassos();
    });

    // selectHover used for hover callback
    let selectHover = new Select({ condition: pointerMove });

    this.map.addInteraction(selectHover);
    selectHover.on('select', (e) => {
      if (e.target.getFeatures().getLength()) {
        this.props.hoverCallBack && this.props.hoverCallBack(e.target.getFeatures().getArray()[0]);
      } else {
        this.props.hoverCallBack && this.props.hoverCallBack(null);
      }
    });

    let dispToolTip;

    document.addEventListener('keydown', (event) => {
      if (event.isComposing || event.keyCode === 16) {
        this.setState({ freeDrawToggle: true });
        return;
      }
    });

    document.addEventListener('keyup', (event) => {
      if (event.isComposing || event.keyCode === 16) {
        this.setState({ freeDrawToggle: false });
        return;
      }
    });

    // drawPoly used for creating lasso polys
    let drawPoly = new Draw({
      source: this.featuresLayer.getSource(),
      style: new Style({
        stroke: new Stroke({
          color: '#FFF',
          width: 3,
        }),
        fill: new Fill({
          color: [255, 255, 255, 1],
        }),
      }),
      type: 'Polygon',
      freehand: this.state.freeDrawToggle,
    });

    drawPoly.on('drawend', (e) => {
      this.handleNewPoly(e);
    });

    //pan and zoom events
    //initiate the currZoom variable

    this.currZoom = this.map.getView().getZoom();
    this.map.on('moveend', this.onMoveEnd);

    this.fitExtent();

    // same map and layer references to local state
    this.setState({ drawPoly: drawPoly });
  }

  fitExtent() {
    let extent;
    if (this.featuresLayer.getSource().getFeatures().length) {
      extent = this.featuresLayer.getSource().getExtent();
    }

    // on page load, extent may not have values defined, so check for them before calling function to avoid error.
    extent &&
      this.map.getView().fit(extent, {
        padding: FIT_PADDING,
      });

    this.props.boundsCallBack &&
      this.props.boundsCallBack(this.map.getView().calculateExtent(this.map.getSize()));
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.focusedPoints !== this.props.focusedPoints) {
      this.setFocusedFeatures(this.props.focusedPoints);
    }

    //update on introduction of data.
    if (prevProps.features && prevProps.features.length === 0 && this.props.features.length) {
      this.addFeatures(this.props.features, 'featuresLayer');
      this.fitExtent();
    } else if (
      (this.props.features.length &&
        prevProps.features.length !== this.props.features.length &&
        (this.props.features[0] || {}).id) ||
      (this.props.uuid && prevProps.uuid && this.props.uuid !== prevProps.uuid)
    ) {
      let prevFeatures = prevProps.features.filter((d) => d != null);
      let newFeatures = this.props.features.filter((d) => d != null);
      let prevFeatureIds = prevFeatures.map((d) => d.id);
      let newFeatureIds = newFeatures.map((d) => d.id);

      let featuresToAdd = [...newFeatures.filter((d) => !prevFeatureIds.includes(d.id))];
      let featuresToRemove = [...prevFeatures.filter((d) => !newFeatureIds.includes(d.id))];
      this.addFeatures(featuresToAdd, 'featuresLayer');
      this.removeFeatures(featuresToRemove, 'featuresLayer');
      if (this.props.displayTextZoomLevel < this.currZoom) {
        this.setPointLabels();
      }
      !this.props.disableFitExtentOnUpdate && this.fitExtent();
    }
  }

  render() {
    return (
      <>
        {/* the map binding point, draw mode is set to change cursor */}
        <div
          className={`ol-map ${this.state.isDrawingPoly ? 'draw-mode' : ''} ${
            this.props.containMap ? 'contained' : ''
          }`}
          id={this.props.target || 'map'}
        />

        {!this.props.hideControls && (
          <div className={'map-custom-controls-wrapper'}>
            {this.buildZoomInOutButtons()}
            {this.buildSwitchTileButton()}
            {this.props.complexControls && (
              <div className={'map-btn-group-2 complex'}>
                {this.buildLassoButton()}
                {this.buildDragButton()}
              </div>
            )}
          </div>
        )}
      </>
    );
  }
}

export default OLMap;
